import type { MessageKey } from 'types/LocaleMessageKey';

interface SizingTip {
  id: number;
  title: MessageKey;
  text: MessageKey;
}

export const sizingTips: SizingTip[] = [
  {
    id: 1,
    title: 'sizing_choose_finger_title',
    text: 'sizing_choose_finger_text',
  },
  {
    id: 2,
    title: 'sizing_comfortable_fit_title',
    text: 'sizing_comfortable_fit_text',
  },
  {
    id: 3,
    title: 'sizing_test_fit_title',
    text: 'sizing_test_fit_text',
  },
  {
    id: 4,
    title: 'sizing_evaluate_fit_title',
    text: 'sizing_evaluate_fit_text',
  },
];
